import { render, staticRenderFns } from "./DoctorNICUPatients.vue?vue&type=template&id=04c9623b&scoped=true"
import script from "./DoctorNICUPatients.vue?vue&type=script&lang=js"
export * from "./DoctorNICUPatients.vue?vue&type=script&lang=js"
import style0 from "./DoctorNICUPatients.vue?vue&type=style&index=0&id=04c9623b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9623b",
  null
  
)

export default component.exports